export default "<ion-app *ngIf=\"!loading\">\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n"